var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dash-page-new',[_c('h1',[_vm._v("Mobile apps businesses will be here")]),_c('code',[_vm._v("businesses : "+_vm._s(_vm.businesses))]),_c('ws-data-table',{attrs:{"items":_vm.businesses,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.number",fn:function(ref){
var index = ref.index;
return [_c('h5',[_vm._v(_vm._s(index + 1))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }